import { LayoutContext } from 'contexts/layoutContext/LayoutContext';
import { Col, Row, Select } from 'plataforma-fundacao-componentes';
import { SelectOptionsType } from 'plataforma-fundacao-componentes/dist/components/select/Select';
import { useContext, useEffect, useState } from 'react';
import { getAgenciasPorCooperativa, getCooperativas } from 'services/Api';
import { getErrorMessages, showToastErrors } from 'utils/ErrorUtils';
import { objectToSelectOptions } from 'utils/InputUtils';
import { languageValues } from 'utils/LanguageUtils';

const texts = languageValues.pages.naoAssociado;

type Props = {
  selecionarAgencia: (value: string) => void;
  selecionarCooperativa: (value: string) => void;
};

export function SelecionarCooperativaAgencia({
  selecionarAgencia,
  selecionarCooperativa,
}: Props) {
  const { showToast } = useContext(LayoutContext);

  const [cooperativas, setCooperativas] = useState<SelectOptionsType[]>([]);
  const [agencias, setAgencias] = useState<SelectOptionsType[]>([]);

  const [cooperativaSelecionada, setCooperativaSelecionada] =
    useState<string>('');
  const [agenciaSelecionada, setAgenciaSelecionada] = useState<string>('');

  useEffect(() => {
    (async () => {
      try {
        const data = await getCooperativas();
        const options = data.map(({ codigo, nome }) =>
          objectToSelectOptions(codigo, nome)
        );
        setCooperativas(options);
      } catch (error) {
        showToastErrors(showToast, getErrorMessages(error));
      }
    })();
  }, [showToast]);

  useEffect(() => {
    const buscarAgencias = async (codCoop: string) => {
      try {
        const data = await getAgenciasPorCooperativa(codCoop);
        const options = data.map(({ codigo, nome }) =>
          objectToSelectOptions(codigo, nome)
        );
        setAgencias(options);
      } catch (error) {
        showToastErrors(showToast, getErrorMessages(error));
      }
    };

    if (cooperativaSelecionada) buscarAgencias(cooperativaSelecionada);
  }, [cooperativaSelecionada, showToast]);

  useEffect(() => {
    selecionarAgencia(agenciaSelecionada);
  }, [agenciaSelecionada, selecionarAgencia]);

  useEffect(() => {
    // Limpa a agência selecionada ao mudar a cooperativa
    setAgenciaSelecionada('');

    selecionarCooperativa(cooperativaSelecionada);
  }, [cooperativaSelecionada, selecionarCooperativa]);

  return (
    <>
      <Row>
        <Col xs={12} md={6}>
          <Select
            label={texts.input.cooperativa.label}
            placeholder={texts.input.cooperativa.placeholder}
            panelFilter
            options={cooperativas}
            onChange={(value) => setCooperativaSelecionada(value)}
            loading={!cooperativas.length}
            value={cooperativaSelecionada}
          />
        </Col>
        <Col xs={12} md={6}>
          <Select
            label={texts.input.agencia.label}
            placeholder={texts.input.agencia.placeholder}
            panelFilter
            options={agencias}
            onChange={setAgenciaSelecionada}
            disabled={!cooperativaSelecionada}
            loading={Boolean(cooperativaSelecionada) && !agencias.length}
            value={agenciaSelecionada}
          />
        </Col>
      </Row>
    </>
  );
}
